import { render, staticRenderFns } from "./FuncSearchGalleryTop.vue?vue&type=template&id=507d5d5a&scoped=true&"
import script from "./FuncSearchGalleryTop.vue?vue&type=script&lang=js&"
export * from "./FuncSearchGalleryTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d5d5a",
  null
  
)

export default component.exports